// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3PJQr","title":"Info_title__3iYLA","links":"Info_links__28pgg","link":"Info_link__1N3Mx","logo":"Info_logo__3bOir"};